module.exports = __webpack_public_path__ + "img/hr-tree-01-h-leaves.04f6fc25.png";